import React from "react";
import { MDBContainer } from "mdbreact";
import { Player } from "video-react";
import "video-react/dist/video-react.css";

import Banner from "../../../template/Banner";
import ShareBtns from "../../../template/ShareBtns";

import bannerImg from "../../../../assets/img/sobre/banner.jpg";

export default () => {
  const description =
    "Centro de Pesquisa e Reabilitação Visual de Itapetininga";

  return (
    <div className="quem-somos">
      <Banner title="QUEM SOMOS" subtitle={description} img={bannerImg} />

      <MDBContainer className="mt-4">
        <ShareBtns
          title={document.title}
          description={description}
          image={bannerImg}
        />
      </MDBContainer>

      <div className="content container d-flex justify-content-center align-items-center flex-column">
        <h1>Sobre a Instituição</h1>
        <p>
          Desde a antiguidade, a cegueira vem sendo considerada como algo de
          difícil compreensão. As pessoas cegas, segundo Lorimer (2000), foram
          sempre consideradas como incapazes e dependentes, maltratadas e
          negligenciadas, sendo que algumas civilizações chegavam mesmo a
          eliminá-las. Somente há 200 anos é que a sociedade começou a perceber
          que as pessoas cegas e com baixa visão poderiam ser educadas e viver
          independentemente. Segundo os resultados do Censo Demográfico 2010,
          (Brasil, 2010) a população do Brasil alcançou a marca de 190.755.799
          habitantes, sendo que 12.777.207 apresentam algum tipo de deficiência
          severa, representando 6,7% da população total. As pessoas com
          deficiência visual severa somam 1.233.006, ou seja, em 2010, 3,5% das
          pessoas declararam possuir grande dificuldade ou nenhuma capacidade de
          enxergar. Podemos desta forma, perceber a urgência atual em se
          desenvolver políticas públicas de assistência à pessoa com deficiência
          visual. Pesquisas realizadas pela Organização Mundial da Saúde (OMS,
          2010) indicam que, se iniciativas de alcance mundial e regional não
          forem tomadas, em 2020 existirão no mundo 75 milhões de pessoas cegas
          e mais de 225 milhões de portadores de baixa visão, ou seja, incapazes
          de desempenhar grande número de tarefas cotidianas devido à
          deficiência visual. Outrossim, o CEPREVI vem ao encontro a estas
          expectativas, tornando-se um Centro de Referência ao atendimento à
          Pessoa com Deficiência Visual, desenvolvendo parcerias com as
          famílias, escolas, comunidade, realizando ainda encaminhamentos à Rede
          Socioassistencial. Neste aspecto, o CEPREVI vem oferecendo serviço
          para a oferta de atendimento especializado as pessoas com deficiência
          visual e suas famílias que tiveram suas limitações agravadas por
          violações de direitos, tais como: isolamento, confinamento, atitudes
          discriminatórias e preconceituosas no seio da família, falta de
          cuidados adequados por parte do cuidador, desvalorização da
          potencialidade/capacidade da pessoa, dentre outras que agravam a
          dependência e comprometem o desenvolvimento da autonomia. O serviço
          tem a finalidade de promover a autonomia, a inclusão social e a
          melhoria da qualidade de vida das pessoas com deficiência visual.
          Conta com equipe específica e habilitada para prestação de serviços
          especializados à pessoa com deficiência visual que necessitam de
          cuidados específicos. A ação da equipe será sempre pautada no
          reconhecimento do potencial dos usuários do serviço SUAS e na
          orientação as suas famílias bem como na aceitação e valorização da
          diversidade. Desta forma, visamos à seguridade da vigilância integral
          dos direitos dos usuários em conformidade com o Plano Nacional de
          Assistência Social (PNAS, 2004), em um processo integral de
          aprendizagem e inclusão das pessoas com deficiência visual na
          sociedade. O Trabalho desenvolvido em grupos socioeducativos deixam
          evidentes que muitas são as dúvidas dos usuários e seus familiares em
          relação aos seus direitos e deveres, principalmente no uso desses no
          seu dia a dia quando a dificuldade em se colocarem se manifesta
          pontualmente. Contudo é notório que o trabalho desenvolvido despertou
          em muitos o interesse de buscar seu direito e esta atitude tem gerado
          nos grupos socioeducativos, líderes. Portanto estes serão usados como
          meio para se obter as ações de conscientização, nos Conselhos de
          Direitos do Município, na Comunidade, Órgãos e Instituições Públicas e
          Privadas a fim de promover a efetivação de seus direitos e deveres. O
          trabalho psicossocial oferecido pela equipe técnica do CEPREVI visa
          também, um conjunto de intervenções que auxiliem o desenvolvimento da
          emancipação das pessoas, para que sejam protagonistas de suas vidas,
          com condições de exercer o seu direito de cidadania. Tendo em vista
          que estas pessoas não vivem sozinhas, o trabalho técnico é estendido
          ao núcleo familiar através de reuniões e visitas domiciliares.
        </p>
        <h1>NOSSA MISSÃO</h1>
        <p>
          Se você, ou alguém que você conhece, possui deficiência visual, é
          possível que exista um problema muito maior. O Centro de Pesquisa e
          Reabilitação Visual de Itapetininga adota uma abordagem holística e
          trata o todo, não apenas a deficiência. Utilizamos diversos
          tratamentos para ajudar pessoas a superar sua deficiência em
          Itapetininga e região desde 02/04/2003. Nunca é tarde demais para nos
          procurar e pedir ajuda.
        </p>

        <MDBContainer className="mt-5">
          <Player
            playsInline
            src={require("../../../../assets/videos/sobre-nos.mp4")}
          />
        </MDBContainer>
      </div>
    </div>
  );
};
